export const TAG_LEVEL_OPTIONS = [
  { label: '一级标签', value: '1' },
  { label: '二级标签', value: '2' },
]

/** 所属标签 pill：按 parentId hash 分配稳定 tone */
const PARENT_TAG_TONES = ['sky', 'violet', 'teal', 'amber', 'rose', 'indigo']

export function getParentTagVariant(parentId) {
  if (parentId === 0 || parentId === '0' || parentId == null || parentId === '') {
    return 'neutral'
  }
  const raw = String(parentId)
  let hash = 0
  for (let i = 0; i < raw.length; i += 1) {
    hash = (hash * 31 + raw.charCodeAt(i)) >>> 0
  }
  return PARENT_TAG_TONES[hash % PARENT_TAG_TONES.length]
}

/**
 * 持久化语义下的「一级标签」判定。
 * - 0 / '0' / null / undefined → 一级
 * - '' 不算一级：那是新建二级时「待选所属一级」的表单中间态
 *   （与 {@link inferTagLevel} 一致，避免列表/表单一端当一级、一端当二级）
 */
export function isTopLevelTag(parentId) {
  return parentId === 0 || parentId === '0' || parentId == null
}

/**
 * 由 parentId 推断 UI 层级。
 * - 0 / '0' / null → 一级
 * - 正整数父级 id → 二级
 * - '' → 新建二级时的「待选所属一级」中间态（也按二级）
 *
 * 为什么 '' 不能当一级：切到二级时会把 parentId 从 0 清成 ''；
 * 若仍推断为一级，会立刻把「二级」按钮弹回去，看起来像点不了。
 */
export function inferTagLevel(parentId) {
  if (parentId === '') {
    return '2'
  }
  return isTopLevelTag(parentId) ? '1' : '2'
}

export function getTagLevelLabel(parentId) {
  return isTopLevelTag(parentId) ? '一级' : '二级'
}

/** 表单/查看弹窗用完整层级文案 */
export function getTagLevelOptionLabel(parentId) {
  const level = inferTagLevel(parentId)
  const match = TAG_LEVEL_OPTIONS.find((item) => item.value === level)
  return match ? match.label : '—'
}

export function getTagLevelVariant(parentId) {
  return isTopLevelTag(parentId) ? 'teal' : 'violet'
}

export function formatParentTagLabel(parentName, parentId) {
  if (isTopLevelTag(parentId)) {
    return '—'
  }
  if (String(parentName || '').trim()) {
    return String(parentName).trim()
  }
  const parsed = Number(parentId)
  if (Number.isFinite(parsed) && parsed > 0) {
    return `ID ${parsed}`
  }
  return '—'
}
